export default __webpack_public_path__ + "static/media/sunlight.217eea07.png";